import script from "./centerRadar3.vue?vue&type=script&setup=true&lang=js"
export * from "./centerRadar3.vue?vue&type=script&setup=true&lang=js"

export default script